import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { deviceTopicsData } from '../data';
import { IDeviceTopicResponse, ISetDeviceTopicSubscriptionRequest } from '../dtos';
import { IDeviceTopicsApiClient } from './i-device-topics-api.client';

@Injectable({
  providedIn: 'root'
})
export class DeviceTopicsInMemoryApiClient implements IDeviceTopicsApiClient {
  constructor(protected http: HttpClient) {}

  get(deviceIdentifier: string): Observable<IDeviceTopicResponse[]> {
    return of(deviceTopicsData.deviceTopicsResponse);
  }

  setSubscription(
    deviceIdentifier: string,
    topicId: string,
    request: ISetDeviceTopicSubscriptionRequest
  ): Observable<void> {
    return of(undefined);
  }
}
